<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item :label="$t('article', 'articleTitle')" prop="title">
        <el-col :xl="10">
          <el-input
            :placeholder="$t('article', 'pleaseEnterTitle')"
            v-model="ruleForm.title"
            clearable
          />
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('article', 'articleSource')" prop="originAuthor">
        <el-col :xl="10">
          <el-input
            :placeholder="$t('article', 'pleaseEnterSource')"
            v-model="ruleForm.originAuthor"
            clearable
          />
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="文章分类" prop="dynamicId">
        <el-select v-model="ruleForm.dynamicId" placeholder="请选择">
          <el-option
            v-for="(item, index) in ['1']"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item :label="$t('article', 'articleCover')"  prop="photos">
        <el-upload
          :action="$store.state.uploadingUrl"
          list-type="picture-card"
          :class="{ disabled: uploadDisabled }"
          :limit="1"
          :on-progress="handProgress"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <div class="h100p d-flex align-items-center">
          <p>{{$t('article', 'uploadImageTip')}}</p>
        </div>
      </el-form-item>
      <el-form-item :label="$t('article', 'articleContent')" prop="details">
        <quill-editor
          style="height: 100%"
          v-model="ruleForm.details"
          ref="myQuillEditor"
          :options="editorOption"
        />
      </el-form-item>
      <el-form-item :label="$t('article', 'isPublish')" prop="isDrafts">
        <el-switch
          v-model="ruleForm.isDrafts"
          :active-text="$t('article', 'publish')"
          :inactive-text="$t('article', 'close')"
        />
        <span class="ml10" style="vertical-align: middle;color: rgb(253, 99, 78);">{{$t('article', 'draftTip')}}</span>
      </el-form-item>
      <el-form-item :label="$t('article', 'isTopArticle')" prop="isTop">
        <el-switch
          v-model="ruleForm.isTop"
          :active-text="$t('article', 'yes')"
          :inactive-text="$t('article', 'no')"
        />
      </el-form-item>
    </el-form>
  </div>
</template> 

<script>
import { quillEditor, Quill } from "vue-quill-editor"; //
import resizeImage from "quill-image-resize-module"; // 调整大小组件。
import { ImageDrop } from "quill-image-drop-module"; // 拖动加载图片组件
import quillConfig from "@/utils/quill-config.js";
import i18nMixin from '@/mixins/i18nMixin';
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/resizeImage ", resizeImage);
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  mixins: [i18nMixin],
  data() {
    var valiIcon = (rule, value, callback) => { // 图片验证
      if (!this.ruleForm.photos) {
        callback();
      } else {
        callback();
      }
    }
    return {
      editorOption: quillConfig,
      disabled: false,
      ruleForm: {
        title: "",
        originAuthor: "",
        dynamicId: "",
        details: "",
        isDrafts: false,
        photos: "",
      },
      fileList: [],
      rules: {
        title: [{ required: true, message: this.$t('article', 'pleaseEnterTitle'), trigger: "blur" }],
        photos: [{ required: true,  }],
        isDrafts: [{ required: true, message: this.$t('article', 'pleaseEnterContent') }],
        details: [{ required: true, message: this.$t('article', 'pleaseEnterContent') }],
      },
    };
  },
  components: {
    quillEditor,
  },
  created() {
    // 在组件创建后设置富文本编辑器的占位符
    this.editorOption.placeholder = this.$t('article', 'pleaseEnterContent');
  },
  beforeDestroy() {
    // 清理表单引用，避免销毁时的警告
    if (this.$refs.ruleForm) {
      this.$refs.ruleForm = null;
    }
  },
  computed: {
    uploadDisabled(){
      return this.ruleForm.photos !== "";
    },
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.photos = "";
    },
    handProgress(event, file, fileList) {
      this.$message({
        message: "正在上传",
      });
    },
    handleSuccess(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.ruleForm.photos = `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${response.data}`;
    },
    submitForm(payload) {
      
      if(!this.ruleForm.photos){
        return this.$message.error(this.$t('article', 'pleaseUploadCover'))
      }
      if(!this.ruleForm.details){
        return this.$message.error(this.$t('article', 'pleaseEnterContent'))
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.ruleForm));
          data.isDrafts = data.isDrafts ? 0 : 1;
          data.isTop = data.isTop ? 1 : 0;
          // if(payload) data.isDrafts = 0 ;
          this.$emit("submitForm", data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .disabled .el-upload--picture-card {
    display: none;
}
</style>